<h1 class="title">Review</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

@if (customer) {
  <div class="details-page-edit-form">
    <div class="form-step">
      <div class="step-name">{{ customer.customerType | titlecase }} Information</div>
    </div>
    @if (customer.customerType === 'BUSINESS') {
      <div class="business-name-item">
        <app-details-item [showPlaceholder]="false" label="Business Name on Account" [value]="customer.businessName"></app-details-item>
      </div>
      <div class="details-row">
        <app-details-item [showPlaceholder]="false" label="First Name" [value]="customer.contactFirstName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Middle Name" [value]="customer.contactMiddleName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Last Name" [value]="customer.contactLastName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Email address" [value]="customer.contactPrimaryEmail"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Mobile number" [value]="customer.contactPrimaryPhoneNumber"></app-details-item>
      </div>
    } @else {
      <div class="details-row">
        <app-details-item [showPlaceholder]="false" label="First name" [value]="customer.firstName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Middle name" [value]="customer.middleName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Last name" [value]="customer.lastName"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Email address" [value]="customer.customerEmailAddress"></app-details-item>
        <app-details-item [showPlaceholder]="false" label="Mobile number" [value]="customer.customerPhoneNumber"></app-details-item>
      </div>
    }
    @if (customer.noteContent) {
      <div class="note-item">
        <app-details-item [showPlaceholder]="false" label="Notes" [value]="customer.noteContent"></app-details-item>
      </div>
    }
    @if (businessCustomerHasAdditionalInformation || individualCustomerHasAdditionalInformation || customerAddress.length) {
      <div>
        <div class="details-separator"></div>
        <div class="form-step">
          <div class="step-name">Additional Information</div>
        </div>
      </div>
    }
    @if (customer.customerType === 'BUSINESS') {
      @if (businessCustomerHasAdditionalInformation) {
        <div class="details-row additional-information">
          @if (customer.dateOfFormation) {
            <app-details-item
              [showPlaceholder]="false"
              label="Date of Formation"
              [value]="customer.dateOfFormation | dateFormat: 'MM/dd/yy' : 'ISO'"
            ></app-details-item>
          }
          @if (customer.taxId) {
            <app-details-item [showPlaceholder]="false" [label]="businessTaxIdLabel" [value]="customer.taxId"></app-details-item>
          }
          @if (customer.doingBusinessAsName) {
            <app-details-item [showPlaceholder]="false" label="Business DBA Name" [value]="customer.doingBusinessAsName"></app-details-item>
          }
          @if (customer.legalName) {
            <app-details-item [showPlaceholder]="false" label="Legal Name of Business" [value]="customer.legalName"></app-details-item>
          }
          @if (customer.businessPrimaryPhoneNumber) {
            <app-details-item
              [showPlaceholder]="false"
              label="Business Primary Phone"
              [value]="customer.businessPrimaryPhoneNumber"
            ></app-details-item>
          }
          @if (customer.website) {
            <app-details-item [showPlaceholder]="false" label="Company website" [value]="customer.website"></app-details-item>
          }
          @if (customer.legalEntityType) {
            <app-details-item [showPlaceholder]="false" label="Type of Business" [value]="customer.legalEntityType"></app-details-item>
          }
          @if (customer.externalId) {
            <app-details-item [showPlaceholder]="false" label="External ID" [value]="customer.externalId"></app-details-item>
          }
          @if (businessCustomerIndustry$ | async; as businessCustomerIndustry) {
            <div>
              <app-details-item [showPlaceholder]="false" label="Industry" [value]="businessCustomerIndustry.name"></app-details-item>
            </div>
          }
          @if (customer.registeredCountryCode) {
            <app-details-item
              [showPlaceholder]="false"
              label="Country of Registration"
              [value]="customer.registeredCountryCode | countryName"
            ></app-details-item>
          }
          @if (customer.operationCountryCodes?.length) {
            <app-details-item
              [showPlaceholder]="false"
              label="Countries of Operation"
              [value]="customer.operationCountryCodes | countryName"
            ></app-details-item>
          }
        </div>
      }
    } @else {
      @if (individualCustomerHasAdditionalInformation) {
        <div class="details-row additional-information">
          @if (customer.dateOfBirth) {
            <app-details-item
              [showPlaceholder]="false"
              label="Date of Birth"
              [value]="customer.dateOfBirth | dateFormat: 'MM/dd/yy' : 'ISO'"
            ></app-details-item>
          }
          @if (customerPlaceOfBirth) {
            <app-details-item [showPlaceholder]="false" label="Place of Birth" [value]="customerPlaceOfBirth"></app-details-item>
          }
          @if (customer.sex) {
            <app-details-item [showPlaceholder]="false" label="Sex" [value]="customerGender"></app-details-item>
          }
          @if (customer.socialId) {
            <app-details-item [showPlaceholder]="false" [label]="socialIdLabel" [value]="customer.socialId"></app-details-item>
          }
          @if (customer.citizenshipCountryCode) {
            <app-details-item
              [showPlaceholder]="false"
              label="Citizenship Country"
              [value]="customer.citizenshipCountryCode"
            ></app-details-item>
          }
          @if (customer.externalId) {
            <app-details-item [showPlaceholder]="false" label="External ID" [value]="customer.externalId"></app-details-item>
          }
        </div>
      }
    }
    @if (customerAddress.length) {
      <div class="additional-information address-list">
        @for (address of customerAddress; track address) {
          <div class="address-type">{{ getAddressTitle($safeNavigationMigration(address?.type), customer.customerType) | titlecase }}</div>
          <div class="details-row">
            <app-details-item
              [showPlaceholder]="false"
              label="Address 1"
              [value]="$safeNavigationMigration(address?.streetLine1)"
              [noBreak]="true"
            ></app-details-item>
            <app-details-item
              [showPlaceholder]="false"
              label="City"
              [value]="$safeNavigationMigration(address?.cityName)"
              [noBreak]="true"
            ></app-details-item>
            <app-details-item
              [showPlaceholder]="false"
              [label]="stateLabel"
              [value]="$safeNavigationMigration(address?.stateCode)"
            ></app-details-item>
            <app-details-item
              [showPlaceholder]="false"
              [label]="postalCodeLabel"
              [value]="$safeNavigationMigration(address?.zipCode)"
              [noBreak]="true"
            ></app-details-item>
            <app-details-item
              [showPlaceholder]="false"
              label="Country"
              [value]="$safeNavigationMigration(address?.countryCode)"
            ></app-details-item>
          </div>
        }
      </div>
    }
  </div>
}

<div class="review-buttons">
  <button rktButton btnType="secondary" title="Back to Edit" (click)="activeModal.close({ action: 'EDIT' })">Back to Edit</button>

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Discard</button>
    <button rktButton type="submit" (click)="activeModal.close({ action: 'SAVE' })" title="Create">Create</button>
  </div>
</div>
